//#region IMPORTS
import { DocumentArrowDownIcon } from "@heroicons/react/24/outline";
import { Fragment } from "react";
//#endregion

//#region INTERFACE
interface Props {
  value: string;
  onChange: (value: string) => void;
  confirmHandler: () => void;
  closeHandler: () => void;
  message?: string;
}
//#endregion

// Shared body for the "Export reference" modal used by both the per-row and the
// bulk instore export. The reference is required (only Week orders open this
// modal), so the Export button stays disabled until the field is filled.
export default function InstoreExportReferenceModalBody({
  value,
  onChange,
  confirmHandler,
  closeHandler,
  message,
}: Props) {
  //#region SETUP
  const disabled = value.trim().length === 0;
  //#endregion

  //#region RENDER
  return (
    <Fragment>
      <div className="sm:flex sm:items-start">
        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-lime-100 sm:mx-0 sm:h-10 sm:w-10">
          <DocumentArrowDownIcon
            className="h-6 w-6 text-lime-600"
            aria-hidden="true"
          />
        </div>
        <div className="mt-3 w-full text-center sm:ml-4 sm:mt-0 sm:text-left">
          <h3 className="text-base font-semibold leading-6 text-gray-900">
            Export reference
          </h3>
          {message && (
            <p className="mt-2 text-sm text-gray-500">{message}</p>
          )}
          <div className="mt-3">
            <input
              type="text"
              autoFocus
              value={value}
              onChange={(e) => onChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !disabled) confirmHandler();
              }}
              placeholder="Export reference"
              className="block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500 sm:text-sm"
            />
            <p className="mt-1 text-xs text-gray-400">
              Required for Week orders.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <button
          type="button"
          disabled={disabled}
          onClick={confirmHandler}
          className="inline-flex w-full justify-center rounded-md bg-lime-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-lime-500 disabled:cursor-not-allowed disabled:opacity-50 sm:ml-3 sm:w-auto"
        >
          Export
        </button>
        <button
          type="button"
          onClick={closeHandler}
          className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
        >
          Cancel
        </button>
      </div>
    </Fragment>
  );
  //#endregion
}
